import { Global, Collection, Jobs } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../components/SeoHead';
import MainBanner from '../../../components/MainBanner';
import LatestNews from '../../../components/LatestNews';
import AllSectors from '../../../components/AllSectors';
import SimpleFormWithBgImage from '../../../components/SimpleFormWithBgImage';
import LatestJobs from '../../../components/LatestJobs';
import LatestTestimonials from '../../../components/LatestTestimonials';

export default function JobSeekersPage({
    global,
    all_news,
    all_sectors,
    all_jobs,
    all_candidate_testimonials
}) {
    return (
        <>
            <SeoHead
                page_name={`Job seekers | Science, Engineering & Life Science Recruitment, Jobs & Staffing | SRG | United States`}
                canonical_link={`job-seekers`}
                en_gb={false}
                en_us={true}
            />
            <MainBanner
                global={global}
                pathPrefix={`us.job_seekers_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Shaping the Future of Life Sciences</h1>
                        <p>As technological advancements accelerate, new fields emerge, and competition intensifies, the demand for professionals in the Life Sciences industry continues to outpace the available talent pool. In fact, life sciences occupations have the second lowest unemployment rate in the nation at 0.6%.</p>
                        <p>Our dedicated team of recruitment specialists will find you the best fit from our outstanding client list and provide amazing career opportunities so you can grow and flourish in your career.</p>
                    </>
                }
                imageURL1={`/site-assets/images/job-seekers-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                imageALT2={`Overlay Main Banner`}
            />
            <LatestJobs
                global={global}
                pathPrefix={`us.job_seekers_page.latest_jobs`}
                customClass={`py-5 grayGradientBg`}
                post={all_jobs}
                content={<>
                    <h2>We have more than 200 live vacancies.</h2>
                    <p>Find our latest tech and digital career opportunities.</p>
                </>
                }
                buttonTitle={``}
                buttonLink={``}
                swiperID={`latestJobsSwiper`}
                jobSearch={true}
                locale={`/us`}
            />
            <LatestTestimonials
                global={global}
                pathPrefix={`us.job_seekers_page.latest_testimonials`}
                customClass={`py-5`}
                content={
                    <>
                        <h2>Candidate's Testimonials</h2>
                    </>
                }
                post={all_candidate_testimonials}
                swiperID={`latestTestimonialsSwiper`}
            />
            <SimpleFormWithBgImage
                global={global}
                pathPrefix={`us.job_seekers_page.simple_form_with_bg_image`}
                sectionId={"join-our-talent-network"}
                customClass={`py-5 position-relative`}
                formId={`68fe6f3f-182f-4f86-9dd2-2cb31df3fa89`}
                content={
                    <>
                        <h2>Join Our Talent Network</h2>
                        <p>Are you looking to take the next steps in your Life Sciences career? Register your resume on this form and let our recruitment team find your next opportunity!</p>
                    </>
                }
                bgImageLink={`/site-assets/images/simpleform-with-bg-image.png`}
                bgImageAlt={`Background Overlay Image`}
                successPageUrl={`/us/job-seekers/submission-success`}
            />
            <AllSectors
                global={global}
                pathPrefix={`us.job_seekers_page.all_sectors`}
                customClass={`py-5`}
                content={
                    <>
                        <h2>Specialist Markets</h2>
                        <p>As the house of global tech and transformation recruitment, we specialise in bringing talent solutions across the full digital spectrum to life. Each one of our solutions is built to the specific needs of our clients, with great variety in size, shape, and scale of design, but with a unifying core of deep tech sector expertise.</p>
                        <p>This gives our clients the unique advantage of tech specialism at scale. Naturally, our background means that we cover all digital skillsets, but there are specific sub-sectors where we provide even deeper levels of insight–often in the places where skills are niche, rare, competitive, or just developing. We call these our Specialist Markets.</p>
                    </>
                }
                post={all_sectors}
            />
            <LatestNews
                global={global}
                pathPrefix={`us.job_seekers_page.latest_news`}
                customClass={`py-5`}
                post={all_news}
                content={
                    <>
                        <h2>The Lorien Pulse: Latest News, Events, and Insights</h2>
                        <p>Our tech expertise and partner-led approach allows us to deliver highly successful results for our clients so they can attract and retain unique talent for their business. Explore our latest collection of case studies, news, events, and insights</p>
                    </>
                }
                buttonLink={`/us/blog/`}
                buttonTitle={`View All Insights`}
                locale={`us/`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const news = (await Collection('news'))
        .filter(function (post) {
            return (
                post.tag?.en.includes("Candidate") && post.country.en == "United States"
            );
        })
    const sectors = await Collection('sectors_us');
    const all_jobs = (await Jobs())
        .filter(function (job) {
            return (
                job.categories
                    // Pulls Sectors only
                    .find((cat) => cat.id === "b4b8be3c-ba95-4912-aa85-2cbc1264449d" && cat.values.find((x) => x.name === "United States"))
            );
        })
        .filter(function (job) {
            return (
                (new Date(job?.expires_at)) >= (new Date())
            )
        })
        .getItems().slice(0, 8);
    const candidate_testimonials = await Collection('candidate_testimonials');

    const all_candidate_testimonials = candidate_testimonials.orderBy('order').getItems();
    const all_sectors = sectors.orderBy('order').getItems();
    const all_news = news.orderBy('date').getItems().slice(0, 8);
    return {
        props: {
            global,
            all_news,
            all_sectors,
            all_jobs,
            all_candidate_testimonials
        }
    };
}
